<div class="w-full h-full bg-pattern" fxLayout="row">

    <div class="left">
        <div class="auth-logo-card" fxLayout="column" fxLayoutGap="10px">
            <img src="assets/puma-logo.png" alt="PUMA Logo" class="logo" />
        </div>
    </div>

    <div class="right">
        <div class="text-center mt-4">
            <h2 class="title m-0" style="color: var(--app-heading)">Check your email!</h2>
            <h4 class="body-2 text-secondary m-0">We’ve sent you a link to reset your password.</h4>
          </div>
          <div @fadeInUp class="overflow-hidden w-full max-w-md">
   
    
            <div class="p-4" fxLayout="column" fxLayoutGap="10px">
                
                <p class="dark-secondary-text text-center">
                    <button mat-button matTooltip="login" type="button"
                        (click)="btnClick();" class="sign-btn">
                        Return to sign in page
                    </button>
                </p>
            </div>
        </div>
    </div>

</div>




